import React, {useEffect, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import WithdrawSearchContainer from '../../../features/page/withdraw/WithdrawSearchContainer'
import WithdrawTable from '../../../features/page/withdraw/WithdrawTable'
import useQueryWithdraw from '../../../hooks/api/withdraw/useQueryWithdraw'
import useQueryWithdrawFailed from '../../../hooks/api/withdraw/useQueryWithdrawFailed'

interface IProps {
    className?: string
}

const WithdrawCashbackPage: React.FC<IProps> = ({className}) => {
    const [status, setStatus] = useState('')
    const {data, refetch} = useQueryWithdraw(status)
    const {data: failedData, refetch: failedRefetch} = useQueryWithdrawFailed()
    const [isOnlyRetry, setIsOnlyRetry] = useState(false)

    useEffect(() => {
        refetch()
    }, [status])

    return (
        <PageLayout title={'Withdraw Cashback'} className={className}>
            <WithdrawSearchContainer
                status={status}
                isOnlyRetry={isOnlyRetry}
                setIsOnlyRetry={e => setIsOnlyRetry(e)}
                onChangedSelect={e => setStatus(e)}
            />
            <WithdrawTable
                paymentFailed={isOnlyRetry}
                data={isOnlyRetry ? failedData?.data : data?.data}
                className={'mt-[30px]'}
            />
        </PageLayout>
    )
}

export default WithdrawCashbackPage
